import React from "react";
import {
  compose,
  withPropsOnChange,
  withStateHandlers,
  branch,
  withHandlers,
} from "recompose";
import { LocalForm, actions } from "react-redux-form";
import {
  Button,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { createSelector } from "reselect";
import { get } from "lodash";
import { formatAccountCurrency } from "../../services/util";
import {
  Page,
  withReload,
} from "components/common";
import { withXeroErrors, AccountSelect } from "components";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import FileModal from "./FileModal";
import BackButton from "components/refactoring/BackButton";


const renderAddressDetails = (addressType, address, t) => {
  const title =
  addressType === t("STREET") ? t("Delivery Address") :
  addressType === t("POBOX") ? t("Tax/Billing Address") :
  t("Unknown Address Type");

  return (
    <div className="col-md-6 my-3">
      <h3>{title}</h3>
      <table className="table table-bordered">
        <tbody>
          {address.AttentionTo && (
            <tr>
              <th><Trans>Attention To</Trans></th>
              <td>{address.AttentionTo}</td>
            </tr>
          )}
          <tr>
            <th><Trans>Country</Trans></th>
            <td>{address.Country}</td>
          </tr>
          <tr>
            <th><Trans>City</Trans></th>
            <td>{address.City || ''}</td>
          </tr>
          <tr>
            <th><Trans>Region</Trans></th>
            <td>{address.Region || ''}</td>
          </tr>
          <tr>
            <th><Trans>Postal Code</Trans></th>
            <td>{address.PostalCode}</td>
          </tr>
          <tr>
            <th><Trans>Address Line</Trans></th>
            <td>{address.AddressLine1}</td>
          </tr>
          <tr>
            <th><Trans>Plot Number</Trans></th>
            <td>{address.AddressLine3}</td>
          </tr>
          <tr>
            <th><Trans>Building Number</Trans></th>
            <td>{address.AddressLine4}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const ContactView = ({
  title,
  setState,
  form,
  item,
  accounts,
  tax_rates,
  dispatch,
  currencies,
  handleAddAnotherPerson,
  handleRemovePerson,
  errors,
  XeroErrors,
  xero,
  history,
  reload,
  t,
  fileModalOpen = false,
  ...props
}) => {
  
  const editLink = () => {
    const { ContactID } = item;
  
    history.push(`/contacts/${ContactID}`)
  };

  const phoneTypes = [
    { type: 'DEFAULT', label: 'Phone Main', index: 1 },
    { type: 'DDI', label: 'Direct Dial', index: 0 },
    { type: 'FAX', label: 'Fax', index: 2 },
    { type: 'MOBILE', label: 'Mobile', index: 3 },
  ];
  
  
    const payableOutstanding = get(item, "Balances.AccountsPayable.Outstanding", 0);
    const payableOverdue = get(item, "Balances.AccountsPayable.Overdue", 0);
    const receivableOutstanding = get(item, "Balances.AccountsReceivable.Outstanding", 0);
    const receivableOverdue = get(item, "Balances.AccountsReceivable.Overdue", 0);

return (
  <Page title={title}>    
    <BackButton/>
    <br/>
    <LocalForm
      initialState={item}
      onUpdate={(form) => setState({ form })}
      onChange={(item) => setState({ item })}
      getDispatch={(dispatch) => setState({ dispatch })}
    >
      {item.ContactID && (
        <div className="d-flex justify-content-end mb-3">
          <Button
            color="primary"
            className="tw-mr-3"
            onClick={() => setState({ fileModalOpen: true })}
          >
            <span className="fa fa-file" />{" "}
            {item.Attachments.length > 0 && item.Attachments.length}
          </Button>
          <UncontrolledButtonDropdown>
            <DropdownToggle caret color="primary" className="btn-sm">
              <Trans>Contact Options</Trans>
            </DropdownToggle>
            <DropdownMenu>
              <Link
                className="dropdown-item"
                to={`/reports/aged_payables_by_contact/${item.ContactID}`}
              >
                <Trans>Aged Payables Report</Trans>
              </Link>
              <Link
                className="dropdown-item"
                to={`/reports/aged_receivables_by_contact/${item.ContactID}`}
              >
                <Trans>Aged Receivables Report</Trans>
              </Link>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
          <button
          type="button"
          className="btn-sm btn btn-primary"
          onClick={editLink}>
          <Trans>Edit Contact</Trans>
        </button>
        </div>
      )}
      <XeroErrors />
      <div>
        <div className="row">
          {/* Contact Information Table */}
          <div className="col-md-6 my-3">
            <h3><Trans>Contact Information</Trans></h3>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th><Trans>Contact Name</Trans></th>
                  <td>{item.Name}</td>
                </tr>
                <tr>
                  <th><Trans>Account Number</Trans></th>
                  <td>{item.AccountNumber}</td>
                </tr>
                <tr>
                  <th><Trans>TRN</Trans></th>
                  <td>{item.TaxNumber}</td>
                </tr>
                <tr>
                  <th><Trans>Primary Person</Trans></th>
                  <td>
                  {item.FirstName && item.LastName
                    ? `${item.FirstName} ${item.LastName}`
                    : item.FirstName
                    ? item.FirstName
                    : item.LastName
                    ? item.LastName
                    : ''}
                  </td>
                </tr>
                <tr>
                  <th><Trans>Email</Trans></th>
                  <td>{item.EmailAddress}</td>
                </tr>
                <tr>
                  <th><Trans>Contact Type</Trans></th>
                  <td>
                    {item.IsCustomer && item.IsSupplier
                      ? t('Supplier and Customer')
                      : item.IsCustomer
                      ? t('Customer')
                      : item.IsSupplier
                      ? t('Supplier')
                      : t('Not Assigned')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Financial Details Table */}
          <div className="col-md-6 my-3">
            <h3><Trans>Financial Details</Trans></h3>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th><Trans>VAT Number</Trans></th>
                  <td>{item.TaxNumber}</td>
                </tr>
                <tr>
                  <th><Trans>Registration Number</Trans></th>
                  <td>{item.CompanyNumber}</td>
                </tr>
                <tr>
                  <th><Trans>ID Type</Trans></th>
                  <td>{item.id_type}</td>
                </tr>
                {item.id_type === 'OTH' && <tr>
                  <th><Trans>ID Name</Trans></th>
                  <td>{item.id_name}</td>
                </tr>}
                <tr>
                  <th><Trans>ID Number</Trans></th>
                  <td>{item.id_number}</td>
                </tr>
                {item.BatchPayments && item.BatchPayments.BankAccountName ? (
                  <tr>
                    <th><Trans>Bank Account Name</Trans></th>
                    <td>{item.BatchPayments.BankAccountName}</td>
                  </tr>
                ) : (
                  <tr>
                    <th><Trans>Bank Account Name</Trans></th>
                    <td><Trans>Not Defined in Xero</Trans></td>
                  </tr>
                )}
                <tr>
                  <th><Trans>Bank Account Number</Trans></th>
                    <td>{item.BankAccountDetails}</td>
                </tr>
                <tr>
                  <th><Trans>Default Currency</Trans></th>
                  <td>{item.DefaultCurrency}</td>
                </tr>
                <tr>
                  <th><Trans>Sales Tax Type</Trans></th>
                  <td>{item.AccountsReceivableTaxType}</td>
                </tr>
                <tr>
                  <th><Trans>Purchases Tax Type</Trans></th>
                  <td>{item.AccountsPayableTaxType}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Addresses Table */}
          {renderAddressDetails(t(item.Addresses[0].AddressType), item.Addresses[0], t)}
          {renderAddressDetails(t(item.Addresses[1].AddressType), item.Addresses[1], t)}
          {/* Phones Table */}
          <div className="col-md-6 my-3">
            <h3><Trans>Contact Numbers</Trans></h3>
            <table className="table table-bordered">
              <tbody>
                {phoneTypes.some(phoneType => item.Phones[phoneType.index]?.PhoneNumber) ? (
                  phoneTypes.map((phoneType) => {
                    const phoneData = item.Phones[phoneType.index];
                    return (
                      phoneData?.PhoneNumber && (
                        <React.Fragment key={phoneType.index}>
                          <tr>
                            <th>{phoneType.label}</th>
                            <td>{`${phoneData.PhoneCountryCode ? `${phoneData.PhoneCountryCode} ` : ''}${phoneData.PhoneNumber}`}</td>
                          </tr>
                        </React.Fragment>
                      )
                    );
                  })
                ) : (
                  <tr>
                    <th><Trans>No contact details found</Trans></th>
                    <td></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Contacts Persons */}
          {(item.ContactPersons && item.ContactPersons.length > 0) && (
            <div className="col-md-6 my-3">
              <h3>Contact Persons</h3>
              <table className="table table-bordered">
                <tbody>
                  {item.ContactPersons.map((contactPerson, idx) => (
                    <React.Fragment key={idx}>
                      <tr>
                        <th>{(item.ContactPersons.length > 1) ? t(`Contact Person ${idx + 1}`) : t('Contact Person')}</th>
                        <td>{`${contactPerson.FirstName} ${contactPerson.LastName}`}</td>
                      </tr>
                      <tr>
                        <th><Trans>Email</Trans></th>
                        <td>{contactPerson.EmailAddress}</td>
                      </tr>
                      <tr>
                        <th><Trans>Include in Emails</Trans></th>
                        <td>{contactPerson.IncludeInEmails ? 'Yes' : 'No'}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {/* Balances */}
        <h3><Trans>Balance</Trans></h3>
        <table className="table">
          <thead>
            <tr>
              <th></th>
              <th className="text-right"><Trans>Invoices owed to you</Trans></th>
              <th className="text-right"><Trans>Bills you need to pay</Trans></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><Trans>Outstanding</Trans></td>
              <td className="text-right">
                {receivableOutstanding ? (
                  <span className="d-block">
                    {formatAccountCurrency(receivableOutstanding)}
                  </span>
                ) : (
                  "-----"
                )}
              </td>
              <td className="text-right">
                {payableOutstanding ? (
                  <span className="d-block">
                    {formatAccountCurrency(payableOutstanding)}
                  </span>
                ) : (
                  "-----"
                )}
              </td>
            </tr>
            <tr>
              <td><Trans>Overdue</Trans></td>
              <td className="text-right">
                {receivableOverdue ? (
                  <span className="text-danger d-block">
                    {formatAccountCurrency(receivableOverdue)}
                  </span>
                ) : (
                  "-----"
                )}
              </td>
              <td className="text-right">
                {payableOverdue ? (
                  <span className="text-danger d-block">
                    {formatAccountCurrency(payableOverdue)}
                  </span>
                ) : (
                  "-----"
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
    </LocalForm>
    {fileModalOpen && (
      <FileModal
        item={item}
        setItem={(item) => setState({ item: item })}
        xero={xero}
        close={() => setState({ fileModalOpen: false })}
      />
    )}
  </Page>
);
}

const currencySelector = createSelector(
  (i) => i,
  (i) =>
    i.map((j) => ({
      ...j,
      Description: `${j.Code} ${j.Description}`,
    }))
);

export const enhance = compose(
  withReload(),
  withStateHandlers(
    {},
    {
      setState: () => (state) => ({ ...state }),
    }
  ),
  withPropsOnChange([], ({ xero, match, setState, t }) => {
    const { id } = match.params;

    Promise.props({
      item:
        id === "new"
          ? {
              Phones: ["DEFAULT", "DDI", "FAX", "MOBILE"].map((PhoneType) => ({
                PhoneType,
              })),
              Addresses: ["POBOX", "STREET"].map((AddressType) => ({
                AddressType,
              })),
              ContactPersons: [],
              PaymentTerms: {},
              BatchPayments: {},
            }
          : xero.get(`contacts/${id}`).get("data"),
      accounts: xero.get("accounts").get("data"),
      tax_rates: xero.get("taxrates").get("data"),
      currencies: xero.get("currencies").get("data").then(currencySelector),
      title: id === "new" ? t("Add Contact") : t("Edit Contact"),
      ready: true,
    }).then(setState);
  }),
  branch(
    (props) => !props.ready,
    () => () => null
  ),
  withXeroErrors(),
  withHandlers({
    handleAddAnotherPerson:
      ({ dispatch }) =>
      () => {
        dispatch(actions.push("local.ContactPersons", {}));
      },
    handleCopyPostal:
      ({ dispatch }) =>
      () => {
        dispatch(actions.change("local."));
      },
    handleRemovePerson:
      ({ dispatch }) =>
      (idx) => {
        dispatch(actions.remove("local.ContactPersons", idx));
      },
  })
);

export default enhance(ContactView);
